// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://nhbmbgjltkursgxqhthy.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5oYm1iZ2psdGt1cnNneHFodGh5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTMwODQzNDEsImV4cCI6MjA2ODY2MDM0MX0.ahaayG4fsnlD5oCF3JD1YmYuJVPB1QX6Q4s7LzfhL3k";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});